// =======================================================
// GETTERS
// =======================================================
export function get_member_reference() {
  return {
    member: localStorage.getItem("reference_id_member"),
    guide:  localStorage.getItem("guide_reference")
  };
}


// =======================================================
// SET DESDE URL (LÓGICA JERÁRQUICA + TOAST)
// =======================================================
export function set_member_reference() {

  const params = new URLSearchParams(window.location.search);

  const memberFromURL = params.get("reference_id_member");
  const guideFromURL  = params.get("guide_reference");

  const memberLS = localStorage.getItem("reference_id_member");
  const guideLS  = localStorage.getItem("guide_reference");

  // ---------------------------------------
  // 1️⃣ NO viene MEMBER → no tocar nada
  // ---------------------------------------
  if (!memberFromURL) {
    console.log("No viene reference_id_member → no se modifica localStorage");
    return;
  }

  // ---------------------------------------
  // 2️⃣ MEMBER
  // ---------------------------------------
  if (!memberLS || memberLS === "null") {

    localStorage.setItem("reference_id_member", memberFromURL);
    console.log("Nuevo MEMBER desde URL:", memberFromURL);
    showToast("New External Member key: " + memberFromURL);

  } else if (memberLS !== memberFromURL) {

    localStorage.setItem("reference_id_member", memberFromURL);
    console.log("Actualizado MEMBER:", memberFromURL);
    showToast("External Member key Update: " + memberFromURL);

  } else {
    console.log("Member sin cambios:", memberFromURL);
  }

  // ---------------------------------------
  // 3️⃣ GUIDE (solo si hay MEMBER)
  // ---------------------------------------
  if (guideFromURL) {

    if (!guideLS || guideLS === "null") {

      localStorage.setItem("guide_reference", guideFromURL);
      console.log("Nuevo GUIDE desde URL:", guideFromURL);
      showToast("New Guide reference: " + guideFromURL);

    } else if (guideLS !== guideFromURL) {

      localStorage.setItem("guide_reference", guideFromURL);
      console.log("Actualizado GUIDE:", guideFromURL);
      showToast("Guide reference Update: " + guideFromURL);

    } else {
      console.log("Guide sin cambios:", guideFromURL);
    }

  } else {
    console.log("Member viene solo, sin guide_reference");
  }

}
  



export function empty_references_storage() {

  // eliminar referencias externas
  localStorage.removeItem("reference_id_member");
  localStorage.removeItem("guide_reference");

  console.log("Referencias eliminadas del localStorage");

  showToast("External references cleared");
}





 function createToastElement() {
    let toast = document.getElementById("toast");
    if (!toast) {
        toast = document.createElement("div");
        toast.id = "toast";
        toast.className = "toast";
        document.body.appendChild(toast);
    }
    return toast;
}

function showToast(message) {
    const toast = createToastElement();
    toast.innerText = message;
    toast.classList.add("show");

    setTimeout(() => {
        toast.classList.remove("show");
    }, 3000);
}